'use client';

import React from 'react';
import { AppStateProvider } from '@/lib/store';
import ErrorBoundary from '@/components/ErrorBoundary';
import DialogHost from '@/components/Dialogs';

/**
 * Client boundary for the root layout. layout.tsx stays a server component so
 * it can export `metadata`; everything stateful hangs off this.
 *
 * The error boundary wraps the provider, not the other way round, so a crash
 * while restoring persisted state is caught too.
 */
export default function Providers({ children }: { children: React.ReactNode }) {
  return (
    <ErrorBoundary>
      <AppStateProvider>
        {children}
        {/* One host for every confirmDialog()/promptDialog() in the app. */}
        <DialogHost />
      </AppStateProvider>
    </ErrorBoundary>
  );
}
